import { Component } from '@angular/core';

@Component({
	selector: 'app-main-loader',
	template: ` <div class="flex flex-col justify-center items-center p-24">
		<h1 class="text-mainColor font-bold text-2xl">Ładowanie...</h1>
		<i class="fa-solid fa-sun animate-spin-slow text-accentColor text-3xl p-4"></i>
	</div>`,
	standalone: true,
})
export class MainLoaderComponent {}
